// extracted by mini-css-extract-plugin
export default {"mainContainer":"resume_mainContainer_S0WDh","contactsLayout":"resume_contactsLayout_obDPW","bannersLayout":"resume_bannersLayout_Y_up1"};